// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Journey A · AnnouncementBar (rifa) ─────────────────────── */
.AnnouncementBar_bar__D1NGB {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 16px;
  background: var(--surface);
  border-bottom: 1px solid var(--line);
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
}
.AnnouncementBar_bar__D1NGB:hover { background: color-mix(in srgb, var(--surface) 88%, var(--teal)); }

.AnnouncementBar_thumb__ykvdI {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  object-fit: cover;
  flex: 0 0 auto;
  border: 1px solid var(--line);
}

.AnnouncementBar_content__wUbw2 {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.AnnouncementBar_title__OKGVu {
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.AnnouncementBar_desc__jpRXj {
  font-size: 12px;
  color: var(--muted);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* progress chip compacto */
.AnnouncementBar_chip__BBB8q {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(69, 230, 194, 0.10);
  border: 1px solid rgba(69, 230, 194, 0.30);
}
.AnnouncementBar_chipBar__UMolp {
  width: 64px;
  height: 6px;
  border-radius: 999px;
  background: rgba(242, 239, 233, 0.14);
  overflow: hidden;
}
.AnnouncementBar_chipFill__naMZ0 {
  height: 100%;
  border-radius: 999px;
  background: var(--teal);
  transition: width .4s ease;
}
.AnnouncementBar_chipNum__wvFCk {
  font-size: 12px;
  font-weight: 700;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.AnnouncementBar_close__XYj9F {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}
.AnnouncementBar_close__XYj9F:hover { background: var(--line); color: var(--ink); }

@media (max-width: 640px) {
  .AnnouncementBar_thumb__ykvdI { display: none; }
  .AnnouncementBar_bar__D1NGB { gap: 10px; padding: 8px 12px; }
  .AnnouncementBar_chipBar__UMolp { width: 44px; }
  .AnnouncementBar_desc__jpRXj { display: none; }
}

/* ── AnnouncementModal ───────────────────────────────────────── */
.AnnouncementBar_overlay__tBAwf {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  animation: AnnouncementBar_ann-fade__pebKj .2s ease;
}
@keyframes AnnouncementBar_ann-fade__pebKj { from { opacity: 0; } to { opacity: 1; } }

.AnnouncementBar_modal__uC-\\+M {
  position: relative;
  width: 100%;
  max-width: 380px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 16px;
  overflow: hidden;
  max-height: 92vh;
  overflow-y: auto;
  animation: AnnouncementBar_ann-pop__YunUP .24s cubic-bezier(.2,.8,.2,1);
}
@keyframes AnnouncementBar_ann-pop__YunUP { from { transform: translateY(8px) scale(.98); opacity: 0; } to { transform: none; opacity: 1; } }

.AnnouncementBar_hero__b6yUu {
  width: 100%;
  aspect-ratio: 9 / 16;
  object-fit: cover;
  display: block;
  background: var(--bg);
}
.AnnouncementBar_modalBody__v5GeW { padding: 22px; }
.AnnouncementBar_modalTitle__EVswT {
  font-size: 19px;
  font-weight: 700;
  color: var(--ink);
  margin: 0 0 6px;
  line-height: 1.25;
}
.AnnouncementBar_modalDesc__l2yE4 {
  font-size: 14px;
  color: var(--muted);
  line-height: 1.55;
  margin: 0 0 18px;
}

.AnnouncementBar_bigBarLabel__inyRl {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 8px;
}
.AnnouncementBar_bigBar__91-Bf {
  height: 12px;
  border-radius: 999px;
  background: rgba(242, 239, 233, 0.14);
  overflow: hidden;
}
.AnnouncementBar_bigFill__g0y82 {
  height: 100%;
  border-radius: 999px;
  background: var(--teal);
  transition: width .5s ease;
}

.AnnouncementBar_incentive__44jE5 {
  margin: 18px 0 0;
  padding: 14px;
  border-radius: 12px;
  background: rgba(200, 165, 91, 0.10);
  border: 1px solid rgba(200, 165, 91, 0.28);
  font-size: 13px;
  line-height: 1.55;
  color: var(--ink);
}

.AnnouncementBar_cta__9U4JN {
  width: 100%;
  margin-top: 18px;
  padding: 13px;
  border-radius: 10px;
  border: none;
  background: var(--teal);
  color: var(--troly-action-ink);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}
.AnnouncementBar_cta__9U4JN:hover { filter: brightness(1.05); }
.AnnouncementBar_ctaHint__I6ISq { font-size: 11px; color: var(--muted); text-align: center; margin-top: 8px; }

.AnnouncementBar_modalClose__h5k3q {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 640px) {
  .AnnouncementBar_overlay__tBAwf { align-items: flex-end; padding: 0; }
  .AnnouncementBar_modal__uC-\\+M {
    max-width: 100%;
    border-radius: 18px 18px 0 0;
    max-height: 88vh;
    animation: AnnouncementBar_ann-drawer__r8ohW .26s cubic-bezier(.2,.8,.2,1);
  }
  @keyframes AnnouncementBar_ann-drawer__r8ohW { from { transform: translateY(100%); } to { transform: none; } }
}
`, "",{"version":3,"sources":["webpack://./src/components/AnnouncementBar/AnnouncementBar.module.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;AACA,oCAAa,+DAA+D,EAAE;;AAE9E;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,sCAAe,uBAAuB,EAAE,iBAAiB,EAAE;;AAE3D;EACE,gCAAS,aAAa,EAAE;EACxB,8BAAO,SAAS,EAAE,iBAAiB,EAAE;EACrC,kCAAW,WAAW,EAAE;EACxB,+BAAQ,aAAa,EAAE;AACzB;;AAEA,mEAAmE;AACnE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mDAA4B;AAC9B;AACA,6CAAsB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE9D;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uEAAgD;AAClD;AACA,4CAAqB,OAAO,qCAAqC,EAAE,UAAU,EAAE,EAAE,KAAK,eAAe,EAAE,UAAU,EAAE,EAAE;;AAErH;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;AACA,oCAAa,aAAa,EAAE;AAC5B;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA,oCAAa,wBAAwB,EAAE;AACvC,kCAAW,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAEtF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAW,qBAAqB,EAAE,UAAU,EAAE;EAC9C;IACE,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,0EAAmD;EACrD;EACA,+CAAwB,OAAO,2BAA2B,EAAE,EAAE,KAAK,eAAe,EAAE,EAAE;AACxF","sourcesContent":["/* ── Journey A · AnnouncementBar (rifa) ─────────────────────── */\n.bar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 8px 16px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--line);\n  cursor: pointer;\n  width: 100%;\n  box-sizing: border-box;\n  text-align: left;\n}\n.bar:hover { background: color-mix(in srgb, var(--surface) 88%, var(--teal)); }\n\n.thumb {\n  width: 38px;\n  height: 38px;\n  border-radius: 8px;\n  object-fit: cover;\n  flex: 0 0 auto;\n  border: 1px solid var(--line);\n}\n\n.content {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.title {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--ink);\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.desc {\n  font-size: 12px;\n  color: var(--muted);\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* progress chip compacto */\n.chip {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 12px;\n  border-radius: 999px;\n  background: rgba(69, 230, 194, 0.10);\n  border: 1px solid rgba(69, 230, 194, 0.30);\n}\n.chipBar {\n  width: 64px;\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(242, 239, 233, 0.14);\n  overflow: hidden;\n}\n.chipFill {\n  height: 100%;\n  border-radius: 999px;\n  background: var(--teal);\n  transition: width .4s ease;\n}\n.chipNum {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--ink);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.close {\n  flex: 0 0 auto;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: var(--muted);\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n}\n.close:hover { background: var(--line); color: var(--ink); }\n\n@media (max-width: 640px) {\n  .thumb { display: none; }\n  .bar { gap: 10px; padding: 8px 12px; }\n  .chipBar { width: 44px; }\n  .desc { display: none; }\n}\n\n/* ── AnnouncementModal ───────────────────────────────────────── */\n.overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n  animation: ann-fade .2s ease;\n}\n@keyframes ann-fade { from { opacity: 0; } to { opacity: 1; } }\n\n.modal {\n  position: relative;\n  width: 100%;\n  max-width: 380px;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  overflow: hidden;\n  max-height: 92vh;\n  overflow-y: auto;\n  animation: ann-pop .24s cubic-bezier(.2,.8,.2,1);\n}\n@keyframes ann-pop { from { transform: translateY(8px) scale(.98); opacity: 0; } to { transform: none; opacity: 1; } }\n\n.hero {\n  width: 100%;\n  aspect-ratio: 9 / 16;\n  object-fit: cover;\n  display: block;\n  background: var(--bg);\n}\n.modalBody { padding: 22px; }\n.modalTitle {\n  font-size: 19px;\n  font-weight: 700;\n  color: var(--ink);\n  margin: 0 0 6px;\n  line-height: 1.25;\n}\n.modalDesc {\n  font-size: 14px;\n  color: var(--muted);\n  line-height: 1.55;\n  margin: 0 0 18px;\n}\n\n.bigBarLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink);\n  margin-bottom: 8px;\n}\n.bigBar {\n  height: 12px;\n  border-radius: 999px;\n  background: rgba(242, 239, 233, 0.14);\n  overflow: hidden;\n}\n.bigFill {\n  height: 100%;\n  border-radius: 999px;\n  background: var(--teal);\n  transition: width .5s ease;\n}\n\n.incentive {\n  margin: 18px 0 0;\n  padding: 14px;\n  border-radius: 12px;\n  background: rgba(200, 165, 91, 0.10);\n  border: 1px solid rgba(200, 165, 91, 0.28);\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--ink);\n}\n\n.cta {\n  width: 100%;\n  margin-top: 18px;\n  padding: 13px;\n  border-radius: 10px;\n  border: none;\n  background: var(--teal);\n  color: var(--troly-action-ink);\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n}\n.cta:hover { filter: brightness(1.05); }\n.ctaHint { font-size: 11px; color: var(--muted); text-align: center; margin-top: 8px; }\n\n.modalClose {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(0, 0, 0, 0.45);\n  color: #fff;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 640px) {\n  .overlay { align-items: flex-end; padding: 0; }\n  .modal {\n    max-width: 100%;\n    border-radius: 18px 18px 0 0;\n    max-height: 88vh;\n    animation: ann-drawer .26s cubic-bezier(.2,.8,.2,1);\n  }\n  @keyframes ann-drawer { from { transform: translateY(100%); } to { transform: none; } }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `AnnouncementBar_bar__D1NGB`,
	"thumb": `AnnouncementBar_thumb__ykvdI`,
	"content": `AnnouncementBar_content__wUbw2`,
	"title": `AnnouncementBar_title__OKGVu`,
	"desc": `AnnouncementBar_desc__jpRXj`,
	"chip": `AnnouncementBar_chip__BBB8q`,
	"chipBar": `AnnouncementBar_chipBar__UMolp`,
	"chipFill": `AnnouncementBar_chipFill__naMZ0`,
	"chipNum": `AnnouncementBar_chipNum__wvFCk`,
	"close": `AnnouncementBar_close__XYj9F`,
	"overlay": `AnnouncementBar_overlay__tBAwf`,
	"ann-fade": `AnnouncementBar_ann-fade__pebKj`,
	"modal": `AnnouncementBar_modal__uC-+M`,
	"ann-pop": `AnnouncementBar_ann-pop__YunUP`,
	"hero": `AnnouncementBar_hero__b6yUu`,
	"modalBody": `AnnouncementBar_modalBody__v5GeW`,
	"modalTitle": `AnnouncementBar_modalTitle__EVswT`,
	"modalDesc": `AnnouncementBar_modalDesc__l2yE4`,
	"bigBarLabel": `AnnouncementBar_bigBarLabel__inyRl`,
	"bigBar": `AnnouncementBar_bigBar__91-Bf`,
	"bigFill": `AnnouncementBar_bigFill__g0y82`,
	"incentive": `AnnouncementBar_incentive__44jE5`,
	"cta": `AnnouncementBar_cta__9U4JN`,
	"ctaHint": `AnnouncementBar_ctaHint__I6ISq`,
	"modalClose": `AnnouncementBar_modalClose__h5k3q`,
	"ann-drawer": `AnnouncementBar_ann-drawer__r8ohW`
};
export default ___CSS_LOADER_EXPORT___;
